import styled from 'styled-components'
import { LayoutConst } from 'core/modules/layout.module'

const MEDIA_QUERY = LayoutConst.screen.mac13
const MEDIA_QUERY_HEIGHT = LayoutConst.screen.height.projectCover

export const Root = styled.div`
  width: 100%;
  max-width: min(1540px, calc(100vw - 120px));
  margin: 0 auto;
  padding: 8px 32px 48px;
  box-sizing: border-box;
  align-self: stretch;
  flex-shrink: 1;
  min-width: 0;
  max-height: calc(100vh - 100px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    max-width: 100%;
    padding: 8px 20px 32px;
    max-height: calc(100vh - 72px);
  }
`

export const MainTitle = styled.h1`
  margin: 0 0 16px;
  width: 100%;
  text-align: left;
  font-family: Inter, sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  color: #151514;
  letter-spacing: -0.02em;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 12px;
  }
`

export const IntroText = styled.p`
  margin: 0 0 24px;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #909090;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    font-size: 13px;
    line-height: 19px;
    margin-bottom: 20px;
  }
`

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 584px;
  box-sizing: border-box;
  padding: 12px 16px;
  margin-bottom: 32px;
  border-radius: 3px;
  background: #f2f2f2;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    margin-bottom: 24px;
    max-width: 100%;
  }
`

export const SearchIconWrap = styled.span`
  display: flex;
  flex-shrink: 0;
  color: #909090;
`

export const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;

  &::placeholder {
    color: #909090;
  }

  &:focus {
    outline: none;
  }
`

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  color: #151514;
`

export const DropdownsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 20px;
  width: 100%;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    grid-template-columns: 1fr;
  }
`

export const DropdownField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

export const PreviewCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  width: 100%;
  margin-bottom: 32px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    margin-bottom: 24px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const TestPreviewCard = styled.button<{ $selected?: boolean }>`
  display: block;
  width: 100%;
  margin: 0;
  padding: 20px 24px;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  background: ${(p) => (p.$selected ? '#def0e5' : '#f2f2f2')};
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition: background 0.15s ease;

  &:hover {
    background: ${(p) => (p.$selected ? '#d4eadf' : '#e8e8e8')};
  }

  &:focus-visible {
    outline: 2px solid #151514;
    outline-offset: 2px;
  }
`

export const PreviewBreadcrumbs = styled.div`
  font-family: Inter, sans-serif;
  font-size: 13px;
  line-height: 18px;
  color: #909090;
  margin-bottom: 12px;
`

export const PreviewCardTitle = styled.h3`
  margin: 0 0 8px;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  color: #151514;
`

export const PreviewCardDescription = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;
`

export const PreviewStatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px 28px;
  margin-top: 16px;
`

export const PreviewStatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 18px;
  color: #151514;
`

export const CopySection = styled.div`
  margin-top: 32px;
`

export const CopyCheckboxStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 4px;
`

export const CopyCheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;

  input {
    margin-top: 2px;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    accent-color: #151514;
  }
`

export const CopyActionSlot = styled.div`
  margin-top: 28px;
  width: fit-content;
  min-width: 220px;
`
import styled from 'styled-components'
import { LayoutConst } from 'core/modules/layout.module'

const MEDIA_QUERY = LayoutConst.screen.mac13
const MEDIA_QUERY_HEIGHT = LayoutConst.screen.height.projectCover

export const Root = styled.div`
  width: 100%;
  max-width: min(1540px, calc(100vw - 120px));
  margin: 0 auto;
  padding: 8px 32px 48px;
  box-sizing: border-box;
  align-self: stretch;
  flex-shrink: 1;
  min-width: 0;
  max-height: calc(100vh - 100px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    max-width: 100%;
    padding: 8px 20px 32px;
    max-height: calc(100vh - 72px);
  }
`

export const MainTitle = styled.h1`
  margin: 0 0 16px;
  width: 100%;
  text-align: left;
  font-family: Inter, sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  color: #151514;
  letter-spacing: -0.02em;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 12px;
  }
`

export const IntroText = styled.p`
  margin: 0 0 24px;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #909090;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    font-size: 13px;
    line-height: 19px;
    margin-bottom: 20px;
  }
`

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 584px;
  box-sizing: border-box;
  padding: 12px 16px;
  margin-bottom: 32px;
  border-radius: 3px;
  background: #f2f2f2;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    margin-bottom: 24px;
    max-width: 100%;
  }
`

export const SearchIconWrap = styled.span`
  display: flex;
  flex-shrink: 0;
  color: #909090;
`

export const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;

  &::placeholder {
    color: #909090;
  }

  &:focus {
    outline: none;
  }
`

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  color: #151514;
`

export const DropdownsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 20px;
  width: 100%;

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    grid-template-columns: 1fr;
  }
`

export const DropdownField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

export const PreviewCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  width: 100%;
  margin-bottom: 32px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  @media (max-width: ${MEDIA_QUERY}px), (max-height: ${MEDIA_QUERY_HEIGHT}px) {
    margin-bottom: 24px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const TestPreviewCard = styled.button<{ $selected?: boolean }>`
  display: block;
  width: 100%;
  margin: 0;
  padding: 20px 24px;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  background: ${(p) => (p.$selected ? '#def0e5' : '#f2f2f2')};
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition: background 0.15s ease;

  &:hover {
    background: ${(p) => (p.$selected ? '#d4eadf' : '#e8e8e8')};
  }

  &:focus-visible {
    outline: 2px solid #151514;
    outline-offset: 2px;
  }
`

export const PreviewBreadcrumbs = styled.div`
  font-family: Inter, sans-serif;
  font-size: 13px;
  line-height: 18px;
  color: #909090;
  margin-bottom: 12px;
`

export const PreviewCardTitle = styled.h3`
  margin: 0 0 8px;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  color: #151514;
`

export const PreviewCardDescription = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;
`

export const PreviewStatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px 28px;
  margin-top: 16px;
`

export const PreviewStatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 18px;
  color: #151514;
`

export const CopySection = styled.div`
  margin-top: 32px;
`

export const CopyCheckboxStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 4px;
`

export const CopyCheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #151514;

  input {
    margin-top: 2px;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    accent-color: #151514;
  }
`

export const CopyActionSlot = styled.div`
  margin-top: 28px;
  width: fit-content;
  min-width: 220px;
`
